var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimetrackingStopDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_9688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E9ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68359 8.18311H18.3174V17.8169H8.68359V8.18311Z",
    fill: "#B2B2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_9688"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetrackingStopDisabled);
export default __webpack_public_path__ + "static/media/time trackingStopDisabled.10d9b1f43f15057f7a370dcee47c29c9.svg";
export { ForwardRef as ReactComponent };